import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-multi-picture-choice-dropdown',
  templateUrl: './multi-picture-choice-dropdown.component.html',
  styleUrls: ['./multi-picture-choice-dropdown.component.less']
})
export class MultiPictureChoiceDropdownComponent implements OnInit, OnDestroy {

  dropdownLabel: string;
  @Input() fieldName: string;
  @Input() keyName: string;
  @Input() sourceList: any[];
  @Input() disabled = false;
  @Input() showOneLine = false;
  @Input() listAnswerId = [];
  @Input() id: number;
  @Input() eventReset: Observable<number>;
  private eventResetSubscription: any;
  showError = false;
  @Input() eventValidate: Observable<number[]>;
  @Input() eventValidateSubscription: any;
  @Input() index: number;

  @Output() userChoice: EventEmitter<number[]> = new EventEmitter<number[]>();

  dropdown: boolean;

  constructor() {
  }

  ngOnInit() {
    this.dropdown = false;
    this.sourceList.forEach(s => {
      s.isChecked = this.listAnswerId.includes(s[this.keyName]);
    });
    this.showDropdownLabel();

    if (this.eventReset) {
      this.eventResetSubscription = this.eventReset.subscribe((position) => {
        if (this.index === position) {
          this.dropdownLabel = '';
          this.sourceList.forEach(s => {
            s.isChecked = false;
          });
          this.showError = false;
        }
      });
    }

    if (this.eventValidate) {
      this.eventValidateSubscription = this.eventValidate.subscribe((listId) => {
        if (listId.includes(this.id)) {
          this.showError = this.sourceList.filter(s => s.isChecked).length === 0;
        } else {
          this.showError = false;
        }
      });
    }
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
      this.userChoice.emit(this.sourceList.filter(s => s.isChecked).map(s => s[this.keyName]));
    }
  }

  toggleDropdown() {
    if (!this.disabled) {
      this.dropdown = !this.dropdown;
    }
  }

  onSelectedAnswer(isChecked: boolean, item: any) {
    item.isChecked = isChecked;
    this.showDropdownLabel();
    this.userChoice.emit(this.sourceList.filter(s => s.isChecked).map(s => s[this.keyName]));
    this.showError = false;
  }

  showDropdownLabel() {
    const listSelectedItem = this.sourceList.filter(s => s.isChecked);
    const length = listSelectedItem.length;
    if (length) {
      if (length === 1) {
        this.dropdownLabel = listSelectedItem[0][this.fieldName];
      } else {
        this.dropdownLabel = '(' + length + ' selected)';
      }
    } else {
      this.dropdownLabel = '';
    }
  }

  getPictureUrl(s: any) {
    let url = this.fieldName ? s[this.fieldName] : s;

    if (url.indexOf('http') < 0) {
      url = environment.blobUrl + url;
    }
    return url;
  }

  ngOnDestroy() {
    if (this.eventResetSubscription) {
      this.eventResetSubscription.unsubscribe();
    }
    if (this.eventValidateSubscription) {
      this.eventValidateSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/multi-picture-choice-dropdown/multi-picture-choice-dropdown.component.ts